import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import AuthService from "services/auth.service";
import ToasterService from "utils/toaster.util";
import { hasPermission } from "utils/privilege.util";

export default function BlockComponent({
  permission,
  /** If set, user needs at least one of these permissions (OR). Overrides `permission` when non-empty. */
  anyOf,
  children,
}: any) {
  const [block, setBlock] = useState(true);
  const permissions = useAppSelector((state) => state.auth?.user?.role_id?.permissions);

  useEffect(() => {
    const list = Array.isArray(permissions) ? permissions : [];
    if (list.length > 0) {
      const keys: string[] =
        Array.isArray(anyOf) && anyOf.length > 0 ? anyOf : permission ? [permission] : [];
      const permissionCheck = keys.some((p) => hasPermission(list, p));

      if (permissionCheck) {
        setBlock(false);
      } else {
        setBlock(true);
      }
    } else {
      setBlock(true);
      ToasterService.showError("Permission denied! Contact your admin.");
    }
  }, [permission, anyOf, permissions]);

  return <>{!block && children}</>;
}
